import CONST from '@/utils/const'

const title = CONST.SYSTEM_SNAME

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js